module.exports = __webpack_public_path__ + "img/2023-01-09e_1.aa09b558.jpg";